export const subadminsKey = "subadmins";
export const subadminRolesKey = "subadminRoles";
export const informationPolicyKey = "informationPolicy";
export const cartKey = "cart";
export const productsKey = "products";
export const categoriesKey = "categories";
/** Event / subscriber categories (CategoryService), distinct from CMS page categories */
export const eventCategoriesKey = "eventCategories";
export const portfolioCategoriesKey = "portfolioCategories";
export const softwaresKey = "softwares";
export const websiteTypesKey = "websiteTypes";
export const brandsKey = "brands";
export const pagesKey = "Pages";
export const bannerKey = "banners";
export const paymentsKey = "payments";
export const widgetsKey = "widgets";
export const adminSettingsKey = "adminSettings";
export const clientsKey = "clients";
export const seoKey = "seo";
export const configSettingsKey = "configSettings";
export const templateKey = "template";
export const couponsKey = "coupons";
export const visitorType = "visitorType";
export const locationKey = "location";
export const cancellationRequest = "cancellation";
export const listingKey = "listings";
export const attributesKey = "attributes";
export const stateKey = "state";
export const countryKey = "country";
export const brandKey = "brand";
export const categoryKey = "category";
export const userKey = "user";
export const ratingKey = "rating";
export const notificationKey = "notificationKey";
export const ordersKey = "orders";
export const returnKey = "return";
export const contactUsKey = "contact-us";
export const collectionKey = "collection";
export const bedKey = "bed";
export const roomKey = "room";
export const roomTypeKey = "roomType";
export const taxCategoryKey = "tax-category";
export const tagKey = "tags";
export const amenityKey = "amenity";
export const listingQuestionsKey = "listingQuestions";
export const bookingQuestionsKey = "bookingQuestions";
export const refundRequestsKey = "refundRequests";
export const servicesKey = "services";
export const FAQKey = "FAQ";
export const TestimonialsKey = "testimonials";
export const teamsKey = "teams";
export const BODKey = "BOD";
export const careersKey = "careers";
export const resumesKey = "resumes";
export const portfolioKey = "portfolio";
export const subServicesKey = "subServices";
export const authorKey = "author";
export const subscribersKey = "subscribers";
export const subscriberEmployeesKey = "subscriberEmployees";
export const subscriberRolesKey = "subscriberRoles";
export const designationKey = "designation";
export const ticketTypeKey = "ticketType";
export const venueKey = "venue";
export const customersKey = "customers";
export const eventsKey = "events";
export const bookingsKey = "bookings";
export const bookingsCalendarKey = "bookingsCalendar";
export const dateChangeKey = "dateChange";
